import { render, staticRenderFns } from "./CardCategory.vue?vue&type=template&id=42c806c8&scoped=true&"
import script from "./CardCategory.vue?vue&type=script&lang=js&"
export * from "./CardCategory.vue?vue&type=script&lang=js&"
import style0 from "./CardCategory.vue?vue&type=style&index=0&id=42c806c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c806c8",
  null
  
)

export default component.exports